import { FileFieldViewModel } from '@/src/shared/presentation/view-models/file-field.viewModel';

import type { ICMSBlockViewModel } from '../../types/cms-block.viewModel';
import type { BackgroundBlock } from '@/src/cms/domain/models/blocks/background-block';

export class BackgroundBlockViewModel implements ICMSBlockViewModel {
  readonly $type = 'background-block' as const;

  hide: boolean;

  fieldImage: FileFieldViewModel;

  fieldVideo: FileFieldViewModel;


  constructor(data: { hide: boolean; fieldImage: FileFieldViewModel; fieldVideo: FileFieldViewModel }) {
    this.hide = data.hide ?? false;
    this.fieldImage = data.fieldImage;
    this.fieldVideo = data.fieldVideo;
  }

  static presenter(block: BackgroundBlock): BackgroundBlockViewModel {
    return new BackgroundBlockViewModel({
      hide: block.hide,
      fieldImage: FileFieldViewModel.presenter(block.fieldImage, 'background'),
      fieldVideo: FileFieldViewModel.presenter(block.fieldVideo, 'background')
    });
  }
}
